/**
 * Anzeige der Lagereinheit (A-lite, Nutzerentscheidung 18.10.2026).
 *
 * Der Server liefert je Position `einheit` ('meter' fuer die Netze-Koepfe, sonst 'stueck').
 * Gerechnet wird nichts: Mengen und EK sind bei Meterware schon heute Meter bzw. EK je m,
 * hier wird es nur sichtbar. Stueck-Artikel bleiben ohne Zusatz wie bisher; ein aelterer
 * Server ohne das Feld zaehlt als Stueck.
 */
import type { Lagereinheit } from "@/api/purchase";

const istMeter = (einheit: Lagereinheit | null | undefined) => einheit === "meter";

/** Zusatz hinter einer Menge: „ m“ bei Meterware, sonst nichts. */
export function einheitZusatz(einheit: Lagereinheit | null | undefined): string {
  return istMeter(einheit) ? " m" : "";
}

/** Menge in deutscher Schreibweise, bei Meterware mit „ m“. */
export function mengeMitEinheit(n: number, einheit: Lagereinheit | null | undefined): string {
  return `${n.toLocaleString("de-DE")}${einheitZusatz(einheit)}`;
}

/** Zusatz hinter einem Preis je Lagereinheit: „ je m“ bei Meterware, sonst nichts. */
export function jeEinheit(einheit: Lagereinheit | null | undefined): string {
  return istMeter(einheit) ? " je m" : "";
}
